var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadlineLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 192,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 144h48V96H96v48zM0 192h48v-48H0v48zM192 48h48V0h-48v48zM48 96h48V48H48v48z",
    fill: "#32324D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144 0h48v24h-24v24h-24V0z",
    fill: "#DCDCE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 0H48v24h24v24h24V0z",
    fill: "#A5A5BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 96h48L0 144V96zM0 48h48L0 96V48zM48 144h48L48 96v48zM144 0H96v48c26.51 0 48-21.49 48-48zM48 0H0v48c26.51 0 48-21.49 48-48z",
    fill: "#4A4A6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 96h24c-13.255 0-24-10.745-24-24v24zm24-48H96v24c0-13.255 10.745-24 24-24zm24 24V48h-24c13.255 0 24 10.745 24 24zm0 0v24h-24c13.255 0 24-10.745 24-24zm-24-9.6a9.6 9.6 0 019.6 9.6 9.6 9.6 0 01-9.6 9.6 9.6 9.6 0 01-9.6-9.6 9.6 9.6 0 019.6-9.6z",
    fill: "#666687"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlineLeft);
export default "/_next/static/images/b6ec7692a57fbe4e10f152c77370641d.svg";
export { ForwardRef as ReactComponent };